"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Id = (function () {
    function Id(id) {
        this.id = id;
        if (id <= 0) {
            throw new RangeError("Unable to construct Id: value must be greater than zero (Given: " + id + ")");
        }
        this.id = id;
    }
    Id.prototype.toJSON = function () {
        return this.id;
    };
    return Id;
}());
exports.Id = Id;
function id(id) {
    return new Id(id);
}
exports.id = id;
//# sourceMappingURL=Id.js.map